import React, { useMemo } from 'react';
import { SGSButton, SGSCard, SGSDeleteIcon, SGSEditIcon, SGSTable } from 'components';
import { useQuery } from 'core/hooks';
import { ArticleMode, ArticleModeRouteNames, ArticleModeRubriqueTypes, Rubrique } from 'core/models';
import { rubriqueService } from 'core/services';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Cell, ColumnInterface } from 'react-table';

type Props = {
    mode: ArticleMode;
};

const ActualiteRubriqueList: React.FC<Props> = ({ mode }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { data, loading, refresh } = useQuery(rubriqueService.getRubriques, ArticleModeRubriqueTypes[mode]);

    const columns = useMemo<ColumnInterface<Rubrique>[]>(
        () => [
            {
                Header: t('rubrique.title'),
                accessor: 'name',
                //minWidth: 250,
                disableFilters: true,
                // headerClassName: styles.tableBorderRight__header,
                // className: `${styles.tableBorderRight__cell} justify-content-center text-center`,
            },
            {
                Header: '',
                accessor: 'none',
                className: 'p-0 align-items-stretch',
                minWidth: 45,
                maxWidth: 45,
                disableFilters: true,
                disableSortBy: true,
                Cell: ({ row }: Cell<Rubrique>) => {
                    return (
                        <div className="w-100 d-flex justify-content-end align-items-center">
                            <SGSEditIcon
                                className="mr-2"
                                onClick={() => {
                                    history.push(`/${ArticleModeRouteNames[mode]}/rubriques/edit/${row.original.id}`);
                                }}
                            />
                            <SGSDeleteIcon
                                onClick={() => rubriqueService.deleteRubrique(row.original.id).then(refresh)}
                            />
                        </div>
                    );
                },
            },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [t],
    );

    return (
        <div>
            <div className="mb-4">
                <SGSButton
                    variant="outlined"
                    className="mr-2"
                    onClick={() => {
                        history.push(`/${ArticleModeRouteNames[mode]}`);
                    }}
                >
                    {t('global.back')}
                </SGSButton>
                <SGSButton
                    onClick={() => {
                        history.push(`/${ArticleModeRouteNames[mode]}/rubriques/create`);
                    }}
                >
                    {t('rubrique.create')}
                </SGSButton>
            </div>
            <SGSCard color="default" className="w-100">
                <SGSTable loading={loading} columns={columns} data={data ?? []} />
            </SGSCard>
        </div>
    );
};

export default ActualiteRubriqueList;
